module.exports = __webpack_public_path__ + "static/media/img_cal1.dbcaf45e.jpg";